/* eslint-disable import/prefer-default-export */

import { useMemo } from 'react';

import { DOCUMENT_TYPES } from '../constants/AppConstants';

export const useDocumentTypes = () => {
  const documentTypeOptions = useMemo(
    () => DOCUMENT_TYPES.map((type) => ({
      id: type.value,
      ...type
    })),
    []
  );

  return {
    documentTypeOptions
  };
};
